module.exports = __webpack_public_path__ + "img/grass.f3a874eb.svg";